import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api-service/api-service';

@Injectable()
export class ShelterNetworkDataService {
  constructor(private apiService: ApiService) {}

  getUsers(columns): Observable<any> {
    const projection = { columns };
    return this.apiService.getShelterClusterUsers({ projection });
  }
}
